var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 17.5536 39.56 15.2101 38.756 13.0436L20 12.174L1.24398 13.0435C0.440078 15.2101 0 17.5536 0 20C0 22.4464 0.440078 24.79 1.24398 26.9565L20 27.8261L38.756 26.9566C39.56 24.79 40 22.4464 40 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.5993 40 35.9302 34.5725 38.7561 26.9565H1.24402C4.06988 34.5725 11.4007 40 20 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24402 13.0436H38.7561C35.9302 5.42756 28.5993 6.10352e-05 20 6.10352e-05C11.4007 6.10352e-05 4.06988 5.42756 1.24402 13.0436V13.0436Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4348 25.6522C17.3133 25.6522 14.7826 23.1216 14.7826 20C14.7826 16.8785 17.3133 14.3478 20.4348 14.3478C21.4081 14.3478 22.324 14.5939 23.1235 15.0272C21.8691 13.8006 20.1538 13.0435 18.2609 13.0435C14.4189 13.0435 11.3044 16.158 11.3044 19.9999C11.3044 23.8419 14.419 26.9564 18.2609 26.9564C20.1539 26.9564 21.8692 26.1993 23.1235 24.9727C22.324 25.4061 21.4081 25.6522 20.4348 25.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7827 16.087L25.5313 18.1925L27.5496 17.233L26.5902 19.2513L28.6957 20L26.5902 20.7488L27.5496 22.7671L25.5313 21.8075L24.7827 23.9131L24.0341 21.8075L22.0157 22.7671L22.9753 20.7488L20.8696 20L22.9753 19.2513L22.0157 17.233L24.0341 18.1925L24.7827 16.087Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzerbaijan);
export default __webpack_public_path__ + "static/media/azerbaijan.9d4d64fa6df57c56c7fc1bb383023860.svg";
export { ForwardRef as ReactComponent };